import React from 'react';
import { PhoneIcon, MessageSquareIcon } from 'lucide-react';
const TryVoxie = () => {
  const personas = [{
    country: 'United States',
    name: 'Voxie',
    number: '505-578-0813',
    canText: true,
    canCall: true,
    flag: '🇺🇸'
  }, {
    country: 'United States',
    name: 'Rhodey',
    number: '917-893-7903',
    canText: true,
    canCall: false,
    flag: '🇺🇸'
  }, {
    country: 'Canada',
    name: 'Soarie',
    number: '365-648-5011',
    canText: true,
    canCall: false,
    flag: '🇨🇦'
  }, {
    country: 'Puerto Rico',
    name: 'Mia',
    number: '939-938-0044',
    canText: true,
    canCall: false,
    flag: '🇵🇷'
  }, {
    country: 'Mexico',
    name: 'Wallie',
    number: '(+52) 55-2061-3042',
    canText: true,
    canCall: false,
    flag: '🇲🇽'
  }];
  return <section id="try-voxie" className="py-12 bg-white" data-id="element-566">
      <div className="container mx-auto px-4" data-id="element-567">
        <div className="bg-[#e5f8f7] p-8 rounded-lg" data-id="element-568">
          <div className="text-center mb-8" data-id="element-569">
            <h3 className="text-2xl font-bold mb-4" data-id="element-570">Try Voxie Now</h3>
            <p className="text-xl mb-2" data-id="element-571">
              Our local directory of AI phone numbers and personas. Each AI will
              respond only to local mobile numbers from its country/area.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-572">
            {personas.map((persona, index) => <div key={index} className="bg-white rounded-lg shadow-md p-6" data-id="element-573">
                <div className="flex items-center mb-4" data-id="element-574">
                  <span className="text-4xl mr-3" aria-hidden="true" data-id="element-575">
                    {persona.flag}
                  </span>
                  <div className="text-left" data-id="element-576">
                    <div className="text-sm text-gray-500" data-id="element-577">
                      {persona.country}
                    </div>
                    <div className="text-xl font-bold text-[#3ba69f]" data-id="element-578">
                      {persona.name}
                    </div>
                  </div>
                </div>
                <div className="text-2xl font-bold text-[#54d4cb] mb-6" data-id="element-579">
                  {persona.number}
                </div>
                <div className="flex flex-col space-y-3" data-id="element-580">
                  {persona.canCall && <a href={`tel:${persona.number.replace(/-/g, '')}`} className="bg-[#54d4cb] text-white px-4 py-2 rounded-md font-medium hover:bg-[#43aca5] transition-colors inline-flex items-center justify-center" data-id="element-581">
                      <PhoneIcon className="h-4 w-4 mr-2" data-id="element-582" />
                      Call Now
                    </a>}
                  {persona.canText && <a href={`sms:${persona.number.replace(/-/g, '')}`} className="bg-[#3ba69f] text-white px-4 py-2 rounded-md font-medium hover:bg-[#2d8a84] transition-colors inline-flex items-center justify-center" data-id="element-583">
                      <MessageSquareIcon className="h-4 w-4 mr-2" data-id="element-584" />
                      Text Now
                    </a>}
                </div>
              </div>)}
          </div>
          <p className="text-gray-500 mt-8 text-sm text-center" data-id="element-585">
            More AI personas coming soon to additional countries!
          </p>
        </div>
      </div>
    </section>;
};
export default TryVoxie;